module.exports = __webpack_public_path__ + "assets/img/logo.d73c72d1.png";